import React, { useState, useRef, useEffect } from "react";
import { List } from "antd";
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { path } from "../../../utils/common/constant";
import { withTranslation } from "react-i18next";
import { projects } from "../../../models/mockdata";
import { getprojects } from "../../../services/projects";
import { encryptString } from "../../../utils/common/hashData";

const Activity = (props) => {
  const [ProjectsData, setProjectsData] = useState([]);
  const [IsloadingData, setIsloadingData] = useState(false);
  const { t } = props;

  const navigate = useNavigate();
  const [currentPage, setCurrentPage] = useState(1);
  const [filter, setFilter] = useState("all");
  const pagesize = 9;

  const getAllProject = async () => {
    try {
      const res = await getprojects(currentPage, pagesize);

      setProjectsData(res.data); // Cập nhật state với dữ liệu hợp lệ

      setIsloadingData(false); // Tắt trạng thái loading
    } catch (err) {
      console.error(err.message);
      setIsloadingData(false); // Tắt trạng thái loading trong trường hợp lỗi
    }
  };
  useEffect(() => {
    getAllProject();
  }, [currentPage]);

  const fadeInUp = {
    hidden: { opacity: 0, y: 100 },
    visible: { opacity: 1, y: 0 },
  };
  const fadeIn = {
    hidden: { opacity: 0 },
    visible: { opacity: 1 },
  };

  const handleChangeFilter = (selectedFilter) => {
    setFilter(selectedFilter);
    setCurrentPage(1);
  };

  const filteredProjects =
    filter === "all"
      ? ProjectsData
      : ProjectsData.filter((project) => project.status === filter);

  return (
    <div>
      <div className="max-w-[1140px] w-[85%] qhd:max-w-[60%] mx-auto gap-10 p-3 rounded-lg my-10">
        <motion.div
          initial="hidden"
          animate="visible"
          variants={fadeInUp}
          transition={{ duration: 0.5 }}
          className="flex justify-center pt-[100px] pv:max-ph:py-10 text-primary"
        >
          <p className="font-bold text-[4.375rem]">{t("activity_title")}</p>
        </motion.div>
      </div>

      <div className="flex w-screen items-center justify-center bg-secondary1 h-44">
        <div className="flex justify-center items-center gap-8 pv:max-ph:flex-col">
          <div
            className={`inline-block cursor-pointer rounded-[10px] border-[2px] px-[42px] py-3 transition-colors duration-200 ${
              filter === "Completed"
                ? "bg-white text-secondary1 border-secondary1"
                : "bg-transparent text-white border-white hover:bg-white hover:text-secondary1"
            }`}
            onClick={() => handleChangeFilter("Completed")}
          >
            {t("activity_complete")}
          </div>
          <div
            className={`inline-block cursor-pointer rounded-[10px] border-[2px] px-[42px] py-3 transition-colors duration-200 ${
              filter === "In Progress"
                ? "bg-white text-secondary1 border-secondary1"
                : "bg-transparent text-white border-white hover:bg-white hover:text-secondary1"
            }`}
            onClick={() => handleChangeFilter("In Progress")}
          >
            {t("activity_progress")}
          </div>
        </div>
      </div>

      <div className="max-w-[1140px] w-[85%] qhd:max-w-[60%] mx-auto gap-10  rounded-lg my-10">
        <motion.div
          initial="hidden"
          animate="visible"
          variants={fadeIn}
          transition={{ duration: 0.5, delay: 0.3 }}
        >
          {filteredProjects.length > 0 ? (
            <List
              grid={{
                gutter: 16,
                xs: 1,
                sm: 1,
                md: 2,
                lg: 2,
                xl: 3,
                xxl: 3,
              }}
              pagination={{
                position: "bottom",
                align: "center",
                pageSize: pagesize,
                current: currentPage,
                total: filteredProjects.length,
                onChange: (e) => {
                  setCurrentPage(e);
                  window.scrollTo({ top: 0, behavior: "smooth" });
                },
              }}
              dataSource={filteredProjects}
              renderItem={(item, index) => (
                <List.Item key={index}>
                  <div
                    key={index}
                    className="transition-transform duration-500 cursor-pointer overflow-hidden group"
                    onClick={(e) => {
                      navigate(
                        "../" +
                          path.common.ACTIVITIY_DETAIL.replace(
                            ":id",
                            encryptString({
                              str: item?.id.toString(),
                              secretKey: process.env.PRIVATE_KEY,
                            })
                          ),
                        {
                          state: {
                            id: encryptString({
                              str: item?.id.toString(),
                              secretKey: process.env.PRIVATE_KEY,
                            }),
                          },
                        }
                      );
                    }}
                  >
                    <div className="relative w-full h-full overflow-hidden shadow-xl">
                      <img
                        src={item.thumbnail}
                        alt={item.name}
                        className="w-full h-[300px] object-cover transition-transform duration-500 "
                      />
                      <div className="absolute bottom-0 left-0 w-full   flex justify-center  bg-black/60 group-hover:bg-secondary1 text-white text-center py-4 transition-colors duration-300">
                        <h3 className="transition-colors duration-300 group-hover:text-white whitespace-nowrap">
                          {item.name}
                        </h3>
                      </div>
                    </div>
                  </div>
                </List.Item>
              )}
            />
          ) : (
            <p className="text-center text-gray-500">
              {t("activity_label_no_activity")}
            </p>
          )}
        </motion.div>
      </div>
    </div>
  );
};

export default withTranslation()(Activity);
